import { Environment } from "shared";
import { isDevSubdomain } from "@web/utils/env/isDevSubdomain";
import { isLocalhost } from "@web/utils/env/isLocalhost";

export function getEnvironment(): Environment {
  if (isLocalhost()) {
    return Environment.Local;
  }

  if (isDevSubdomain()) {
    return Environment.Development;
  }

  return process.env.NEXT_PUBLIC_ENV as Environment;
}
